
import {
    GET_ALL_ACTIVE_AMENITIES
   } from "../../constant/ActionType";
   
   export default function GetAllAmenities(state = {
       AllAcitveAmenitiesData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_ACTIVE_AMENITIES:
               return {
                   ...state,
                   AllAcitveAmenitiesData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }